<div *ngIf="aberto" class="fixed inset-0 z-50 flex items-center justify-center p-4"
  style="background-color: rgba(0,0,0,0.55)">
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[92vh] flex flex-col"
    style="border: 1px solid var(--flua-borda)">

    <!-- Cabeçalho -->
    <div class="px-5 py-4 flex items-center justify-between rounded-t-xl"
      style="background-color: var(--brand-primary)">
      <div class="flex items-center gap-2 text-white">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
        </svg>
        <h3 class="text-base font-semibold">Responsável Legal</h3>
        <span *ngIf="obrigatorio" class="ml-1 px-2 py-0.5 rounded text-xs font-bold"
          style="background-color: #fff8e1; color: #8a6900">Obrigatório</span>
      </div>
      <button type="button" (click)="fechar.emit()"
        class="text-white text-xl font-bold w-7 h-7 flex items-center justify-center rounded hover:bg-white/20">
        ×
      </button>
    </div>

    <!-- Corpo (scroll) -->
    <div class="px-5 py-4 overflow-y-auto flex-1 flex flex-col gap-4 text-sm">

      <!-- Busca por CPF já cadastrado -->
      <div class="rounded-lg p-3 flex flex-col gap-2" style="background-color: var(--flua-fundo); border: 1px dashed #D6CFC2">
        <label class="text-xs font-medium" style="color: var(--tx-2)">
          Buscar responsável já cadastrado (CPF)
        </label>
        <div class="flex gap-2">
          <input type="text" [(ngModel)]="buscaCpf" (input)="onBuscaCpfInput()"
            placeholder="Digite o CPF (11 dígitos)" maxlength="14"
            class="flex-1 rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
          <button type="button" (click)="buscarPorCpf()" [disabled]="isBuscando"
            class="px-4 py-2 rounded-lg text-white text-xs font-semibold"
            style="background-color: var(--brand-primary)">
            {{ isBuscando ? 'Buscando...' : 'Buscar' }}
          </button>
        </div>
        <p *ngIf="buscaMsg" class="text-xs" [style.color]="buscaErro ? '#d34747' : '#1f6f43'">
          {{ buscaMsg }}
        </p>
      </div>

      <!-- Dados do Responsável -->
      <p class="text-xs font-semibold uppercase" style="color: var(--brand-primary); letter-spacing: .05em">
        Dados do Responsável
      </p>

      <div class="flex flex-col gap-1">
        <label class="text-xs font-medium" style="color: var(--tx-2)">Nome completo <span
            style="color:#d34747">*</span></label>
        <input type="text" [(ngModel)]="form.nmContato"
          class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
          style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">CPF <span style="color:#d34747">*</span></label>
          <input type="text" [value]="formatarCpf(form.nrCpf)" (input)="onCpfInput($event)" maxlength="14"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">E-mail</label>
          <input type="email" [(ngModel)]="form.dsEmail"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
      </div>

      <div class="grid grid-cols-3 gap-3">
        <div class="flex flex-col gap-1 col-span-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">DDD <span style="color:#d34747">*</span></label>
          <input type="text" [(ngModel)]="form.nrDdd" maxlength="3"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
        <div class="flex flex-col gap-1 col-span-2">
          <label class="text-xs font-medium" style="color: var(--tx-2)">Telefone/Celular <span
              style="color:#d34747">*</span></label>
          <input type="text" [(ngModel)]="form.nrTelefone" maxlength="11"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
      </div>

      <!-- Endereço -->
      <p class="text-xs font-semibold uppercase mt-2" style="color: var(--brand-primary); letter-spacing: .05em">
        Endereço do Responsável
      </p>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">CEP <span style="color:#d34747">*</span></label>
          <input type="text" [value]="formatarCep(form.cdCep)" (input)="onCepInput($event)"
            (blur)="buscarCep()" maxlength="9" class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
          <span *ngIf="isBuscandoCep" class="text-xs" style="color: var(--brand-primary)">Buscando...</span>
        </div>
        <div class="flex flex-col gap-1 md:col-span-2">
          <label class="text-xs font-medium" style="color: var(--tx-2)">Logradouro <span
              style="color:#d34747">*</span></label>
          <input type="text" [(ngModel)]="form.dsEndereco"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">Número <span style="color:#d34747">*</span></label>
          <input type="text" [value]="form.nrEndereco" (input)="onNumeroInput($event)" inputmode="numeric"
            maxlength="5" class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">Complemento</label>
          <input type="text" [(ngModel)]="form.dsComplemento" maxlength="40"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">Bairro <span style="color:#d34747">*</span></label>
          <input type="text" [(ngModel)]="form.dsBairro"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">Cidade <span style="color:#d34747">*</span></label>
          <input type="text" [(ngModel)]="form.dsMunicipio"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs font-medium" style="color: var(--tx-2)">UF <span style="color:#d34747">*</span></label>
          <input type="text" [(ngModel)]="form.sgEstado" maxlength="2"
            class="w-full rounded-lg border px-3 py-2 text-sm outline-none uppercase"
            style="border-color: var(--flua-borda); color: var(--tx); background-color: var(--cartao)" />
        </div>
      </div>

      <!-- Erros -->
      <div *ngIf="erros.length > 0" class="rounded-lg px-3 py-2 text-xs"
        style="background-color: #fdecec; border: 1px solid #f5c6c6; color: #a03030">
        <p class="font-semibold mb-1">Verifique os campos:</p>
        <ul class="list-disc ml-4">
          <li *ngFor="let e of erros">{{ e }}</li>
        </ul>
      </div>
    </div>

    <!-- Rodapé -->
    <div class="px-5 py-3 flex items-center justify-end gap-2 border-t rounded-b-xl"
      style="border-color: var(--flua-borda); background-color: var(--flua-rodape)">
      <button type="button" (click)="fechar.emit()" class="px-4 py-2 rounded-lg text-sm font-semibold"
        style="background-color: #8c8c8c; color: white">
        Cancelar
      </button>
      <button type="button" (click)="salvar()" [disabled]="isSalvando"
        class="px-5 py-2 rounded-lg text-sm font-semibold text-white" style="background-color: var(--brand-primary)">
        {{ isSalvando ? 'Salvando...' : 'Salvar Responsável' }}
      </button>
    </div>

  </div>
</div>
